import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { State, process, GroupResult } from "@progress/kendo-data-query";
import * as $ from "jquery";
import { environment } from "@env/environment";
import { LocalStorageService } from "@app/shared/services/local-storage/local-storage.service";
import { FormBuilder } from "@angular/forms";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { startWith, map } from "rxjs/operators";
import { GlobalService } from "@app/shared/services/global/global.service";
import { CompanyService } from "@app/modules/company/services/company.service";
import { LeadsService } from "@app/modules/leads/services/leads.service";

export interface StateGroup {
  letter: string;
  names: string[];
}

export const _filter = (opt, value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.name.toLowerCase().includes(filterValue));
};

@Component({
  selector: "crm-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.scss"],
})
export class NavBarComponent implements OnInit {
  defaultImagePath = environment.defaultImagePath;

  private groupedData: GroupResult[];
  public companyList = [];
  private cList = [];
  private lList = [];
  public leadsList = [];
  stateGroups;
  stateForm = this.fb.group({
    query: "",
  });
  public state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: "and",
      filters: [],
    },
  };
  userInfo: any;
  imageUrl: any;
  userName: any;
  limit = "5";
  page = "1";
  sortno = "1";
  sortnane = "";
  params = {
    limit: this.limit,
    page: this.page,
    sortno: this.sortno,
    sortnane: this.sortnane,
    client_company_id: 1,
    search: {
      company_name: "",
      company_contact: "",
      company_contact_mob: "",
      company_phone: "",
      company_email: "",
      company_website: "",
      company_country_id: "",
      company_state: "",
      company_city: "",
      company_address1: "",
      company_address2: "",
      company_address3: "",
      company_address4: "",
      company_zip: "",
      company_postal_code: "",
    },
  };
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: "contains",
  };
  leadparams = {
    limit: this.limit,
    page: this.page,
    sortno: this.sortno,
    sortnane: this.sortnane,
    client_company_id: 1,
    search: {
      title: "",
      leadSource: "",
      description: "",
    },
  };
  public gridView: any;
  showDropDown = true;

  constructor(
    private router: Router,
    private companyService: CompanyService,
    private localStorageService: LocalStorageService,
    private leadsService: LeadsService,
    private fb: FormBuilder,
    private _globalService: GlobalService,
    private cdr: ChangeDetectorRef
  ) {
    this.initForm();
  }

  initForm() {
    console.log("search");
    return (this.stateForm = this.fb.group({
      query: [""],
    }));
  }

  stateGroupOptions;

  private _filterGroup(value: string) {
    console.log("filtered:", value);
    if (value) {
      console.log("inside:", value);
      return this.gridView
        .map((group) => ({
          category: group.category,
          field: _filter(group.field, value),
        }))
        .filter((group) => group.field.length > 0);
    }

    console.log("returned value:", this.gridView);
    return this.gridView;
  }

  ngOnInit() {
    const d = this.localStorageService.getLocalStorageItem('response')
    console.log("this.name::", d)
    this.stateGroupOptions = this.stateForm.get("query").valueChanges.pipe(
      startWith(""),
      map((value) => this._filterGroup(value || ""))
    );

    console.log("recived search value:", this.stateGroupOptions);
    this.getUserInfo();
    this.getCompany(this.params);
    this.getLeads(this.leadparams);

    // this.companyService.getSelectedCompanyById().subscribe((response) => {
    //   console.log(response);
    // })
  }

  navigateToDashboard() {
    this.router.navigate(["/dashboard"]);
  }

  getUserInfo() {
    this.userInfo = this.localStorageService.getLocalStorageItem("response")
    this.userName = (this.localStorageService.getLocalStorageItem("response")).data.user.username;
    console.log("userInfo::1:", this.userInfo)
  }

  logOut(): void { }

  goToProfile() {
    console.log("i pr");
    this.router.navigate(["/profile/"]);
  }

  selectValue(value) {
    this.stateForm.patchValue({ search: value });
    this.showDropDown = false;
  }

  closeDropDown() {
    this.showDropDown = !this.showDropDown;
  }

  openDropDown() {
    this.showDropDown = false;
  }

  getSearchValue() {
    return this.stateForm.value.search;
  }

  getCompany(body): void {
    const payload = { page: 1, limit: 200 };
    this.companyService.getCompanyList(payload).subscribe(
      (response) => {
        console.log("company response:", response);
        this.companyList = response.data;
        for (let a of this.companyList) {
          this.cList = [
            ...this.cList,
            { name: a.company_name, id: a.company_id },
          ];
        }
        this.gridView = [
          ...(this.gridView || []),
          { category: "Company", field: this.cList },
        ];
      },
      (error) => {
        this.gridView = [];
      }
    );
  }

  navigateToCompanyDetail(company: any): void {
    console.log("company", company);
    this.router.navigate(["/company/view", company]);
  }

  navigateToLeads() {
    this.router.navigate(["/leads"]);
  }

  getLeads(body): void {
    this.leadsService.getSearchLeadsList(body).subscribe(
      (response) => {
        if (response.status) {
          this.leadsList = response.data;
          for (let a of this.leadsList) {
            this.lList = [...this.lList, { name: a.title, id: a.lead_id }];
          }
          this.gridView = [
            ...(this.gridView || []),
            { category: "Leads", field: this.lList },
          ];
        } else {
          this.gridView = [];
        }
      },
      (error) => { }
    );
  }

  handleFilter(value) {
    console.log(value);
    this.gridView = this.gridView.filter(
      (s) =>
        (s.company_name &&
          s.company_name.toLowerCase().indexOf(value.toLowerCase()) !== -1) ||
        (s.title && s.title.toLowerCase().indexOf(value.toLowerCase()) !== -1)
    );
  }

  myListParem: any;
  myListParemLen: 0;
  private searchTimeout: any;
  viewVisibility: boolean = false;
  newData: Array<any> = [];
  arrayList: any;
  searchList: any;
  searchQuery: any = "";

  // Modified globalSearchbar for debouncing
  globalSearchbar(event: any) {
    this.viewVisibility = true;
    const q1 =
      event && event.target && event.target.value
        ? event.target.value.trim()
        : "";

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (!q1 || q1 === "") {
      this.searchList = { companies: [], leads: [] }; // Clear results if query is empty
      this.cdr.detectChanges();
      return;
    }

    this.searchTimeout = setTimeout(() => {
      const searchBody = { query: q1 };
      this._globalService.globalSearchService(searchBody).subscribe(
        (res) => {
          this.searchList = res && res.data ? res.data : [];
          this._globalService.setGlobalSearchResults(this.searchList);
          console.log("global search res:", res);
          this.cdr.detectChanges();
        },
        (error) => {
          this.searchList = { companies: [], leads: [] };
          this._globalService.clearGlobalSearchResults();
        }
      );
    }, 500); // 0.5 second debounce
  }

  selectRecommendation(selectRecommendationData: any) {
    this.viewVisibility = false;
    console.log("global selectRecommendationData:", selectRecommendationData);

    this.searchQuery =
      selectRecommendationData && selectRecommendationData.userName
        ? selectRecommendationData.userName
        : "";

    if (selectRecommendationData && selectRecommendationData.lead_id) {
      this.router.navigate([
        "/lead-contacts/global_lead_search",
        selectRecommendationData.lead_id,
      ]);
    } else if (
      selectRecommendationData &&
      selectRecommendationData.company_id
    ) {
      this.router.navigate([
        "/company/global_lead_search",
        selectRecommendationData.company_id,
      ]);
    } else {
      console.log("Neither company_id nor lead_id found.");
    }
  }

  // New method for Enter key press
  onEnter() {
    this.viewVisibility = false;
    // Clear any pending debounce timeout to ensure immediate search
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    const q1 = this.searchQuery.trim();
    if (!q1) {
      return; // Do nothing if search query is empty
    }

    const searchBody = { query: q1 };
    this._globalService.globalSearchService(searchBody).subscribe(
      (res) => {
        this.searchList = res && res.data ? res.data : [];
        this._globalService.setGlobalSearchResults(this.searchList);
        console.log("global search on Enter res:", res);
        this.arrayList = this.searchList; // Set arrayList for navigation
        this.router.navigate(["/search/list", 1]); // Navigate to search results page
        this.searchQuery = ""; // Clear search query after navigation
        this.cdr.detectChanges();
      },
      (error) => {
        this.searchList = { companies: [], leads: [] };
        this._globalService.clearGlobalSearchResults();
        this.searchQuery = ""; // Clear search query on error
      }
    );
  }
}
